import { CircularProgress } from "@mui/material";

export default function LoadingIndicator() {
  return (
    <>
      <>
        <CircularProgress
          sx={{
            width: "50%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      </>
    </>
  );
}
